import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Map } from 'immutable';

import Loading from '../../../Loading';

import { CreateAccountForm } from './CreateAccountForm';

class CreateAccountTab extends React.PureComponent {
    static propTypes = {
        status: PropTypes.string,
        errors: ImmutablePropTypes.map,
        onCreateRequest: PropTypes.func.isRequired
    };

    static defaultProps = {
        errors: Map()
    };

    create(data) {
        data = Object.assign({}, data);

        const mobilePrefix = data.mobilePrefix.split(',');

        data.mobilePhone = {
            prefix: mobilePrefix[0].replace('-', ''),
            country: mobilePrefix[1],
            number: data.mobilePhone
        };

        if (data.landlinePrefix) {
            const landlinePrefix = data.landlinePrefix.split(',');

            data.landlinePhone = {
                prefix: landlinePrefix[0].replace('-', ''),
                country: landlinePrefix[1],
                number: data.landlinePhone
            };
        }

        data.contactPreferences = [ 'email', 'phone', 'sms' ].filter( key => {
            const isAvailable = data[ `contactPreferences.${key}` ];

            delete data[ `contactPreferences.${key}` ];

            return isAvailable;
        } );

        delete data.mobilePrefix;
        delete data.landlinePrefix;

        this.props.onCreateRequest(data);
    }

    render() {
        const { errors, debug, status } = this.props;

        return (
            <div>
                <CreateAccountForm
                    errors={ errors }
                    debug={debug}
                    onSubmit={ this.create.bind(this)}
                />

                <Loading active={ status === 'IN_PROGRESS' } message='Creating customer' />
            </div>
        );
    }
}

export default CreateAccountTab;
